<div style="height: 850px;" data-cy="ar-payment">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="ar-payment-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="ar-payment-header">
      <div class="section-header-title" data-cy="ar-payment-title">
        Receive Payment from {{ type }}
      </div>
      <div style="flex: 1;" data-cy="ar-payment-header-spacer"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; display: flex; flex-direction: column; height: 100%;" data-cy="ar-payment-content">
      <app-tdo-progress-spinner style="height: 100%;" *ngIf="isLoading" data-cy="ar-payment-spinner"></app-tdo-progress-spinner>
      <div *ngIf="!isLoading" style="flex: 1; overflow-y: hidden;" data-cy="ar-payment-loaded-content">

        <!--  body of modal-->

        <div class="flexbox-container" style="width:100% !important; flex-wrap: nowrap;" data-cy="ar-payment-container">

          <div class="flexbox-container-column" style="flex: 1" data-cy="ar-payment-left-column">

            <div class="top-left-column"
              style="background: var(--tdo-purple-light); padding-top: 10px; padding-bottom: 10px; margin-bottom: 10px; font-weight: bold" data-cy="ar-payment-patient-name">
              Payment for: {{ this.globals.currentPatientFullName }}</div>

            <div class="flexbox-item top-left-column input-container-height" data-cy="ar-payment-from-container">
              <mat-form-field class="flex-column-item mat-select-margin" style="width:100% !important;" data-cy="ar-payment-from-field">
                <mat-label data-cy="ar-payment-from-label">From</mat-label>
                <mat-select data-cy="pay-from-list" [(ngModel)]="selectedContact" [disabled]="this.applyPayment">
                  <mat-option data-cy="pay-from-list-option" *ngFor="let contact of contactList" [value]="contact">
                    {{ contact?.FirstName + ' ' + contact?.LastName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="flexbox-item top-left-column input-container-height-middle" data-cy="ar-payment-amount-container">
              <div style="display: flex; flex-direction: row" data-cy="ar-payment-amount-row">
                <div style="flex-basis: 85%" data-cy="ar-payment-amount-input-container">

                  <mat-form-field class="flex-column-item mat-select-margin" style="width:100% !important;"
                    *ngIf="this.selectedLedgerItem" data-cy="ar-payment-credit-amount-field">
                    <mat-label data-cy="ar-payment-credit-amount-label">Credit Amount</mat-label>
                    <input matInput data-cy="pay-amount" [disabled]="true"
                      [value]="paymentAmount | currency:'USD':'symbol'"
                      (change)="saveCurrencyField($event, 'paymentAmount', '');">
                  </mat-form-field>

                  <div style="max-height: 100px; overflow-y: auto; border-color: #00A1DD; border-width: 0px ; border-bottom-width: 2px; border-style: solid; padding-top: 10px; padding-bottom: 10px " *ngIf="!this.selectedLedgerItem" data-cy="ar-payment-doctor-amounts">
                    <div *ngFor="let charge of PaymentAmountForDoctors" data-cy="ar-payment-doctor-amount-row">
                      <div style="display: flex; height: 24px" data-cy="ar-payment-doctor-amount-item">
                        <mat-checkbox [(ngModel)]="charge.isSelected"
                          (change)="PaymentAmountForDoctorSelection(charge)" data-cy="ar-payment-doctor-checkbox"></mat-checkbox>
                        <div style="width: 180px" data-cy="ar-payment-doctor-name">
                          {{charge.DoctorName}}
                        </div>
                        <div
                          style="width: 70px; margin-right: 3px; border-width: 1px;border-style: solid;border-color: #00A1DD" data-cy="ar-payment-doctor-amount-input-container">
                          <input matInput data-cy="pay-amount" [disabled]="!charge.isSelected"
                            [ngModel]="charge.amount | currency:'USD':'symbol'"
                            (blur)="charge.amount=$event.target.value.replace('$','').replace(',','');" data-cy="ar-payment-doctor-amount-input">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="flex-basis: 15%;" data-cy="ar-payment-credit-button-container">
                  <div
                    [matTooltip]="dataCreditLedgerItems.length > 0 ? 'Credit exists - click to apply' : 'No credit available'" data-cy="ar-payment-credit-tooltip">
                    <button data-cy="pay-credit-btn" mat-mini-fab color="primary"
                      [disabled]="dataCreditLedgerItems.length < 1 || this.applyPayment"
                      (click)="openChooseLedgerItemWindow()">
                      <mat-icon>payments</mat-icon>
                    </button>
                  </div>

                </div>
              </div>

            </div>

            <div class="flexbox-item top-left-column input-container-height" style="margin-top: 10px;" data-cy="ar-payment-date-container">
              <mat-form-field class="flex-column-item mat-select-margin" style="width:100% !important;" data-cy="ar-payment-date-field">
                <mat-label data-cy="ar-payment-date-label">Post Date</mat-label>
                <input data-cy="pay-date" matInput [matDatepicker]="dateReceivedPicker" [(ngModel)]="datePostPayment"
                  [disabled]="this.applyPayment" [min]="this.dateReceivedMin">
                <mat-datepicker-toggle matSuffix [for]="dateReceivedPicker" data-cy="ar-payment-date-toggle"></mat-datepicker-toggle>
                <mat-datepicker #dateReceivedPicker data-cy="ar-payment-date-picker"></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="flexbox-item top-left-column input-container-height" data-cy="ar-payment-received-date-container">
              <mat-form-field class="flex-column-item mat-select-margin" style="width:100% !important;" data-cy="ar-payment-received-date-field">
                <mat-label data-cy="ar-payment-received-date-label">Date Received</mat-label>
                <input data-cy="pay-received-date" matInput [matDatepicker]="dateReceivedPaymentPicker" [(ngModel)]="dateReceivedPayment"
                  [disabled]="this.applyPayment || this.isDisabledReceivedDate" [min]="this.dateReceivedMin">
                <mat-datepicker-toggle matSuffix [for]="dateReceivedPaymentPicker" data-cy="ar-payment-received-date-toggle"></mat-datepicker-toggle>
                <mat-datepicker #dateReceivedPaymentPicker data-cy="ar-payment-received-date-picker"></mat-datepicker>
              </mat-form-field>
            </div>

          </div>

          <div class="flexbox-container-column" style="flex: 1; margin-right: 10px;" data-cy="ar-payment-middle-column">

            <div class="top-left-column"
              style="background: var(--tdo-purple-light); padding-top: 10px; padding-bottom: 10px; margin-bottom: 10px; font-weight: bold" data-cy="ar-payment-middle-header">
              &nbsp;</div>

            <div class="flexbox-item top-center-column input-container-height" data-cy="ar-payment-type-container">
              <mat-form-field class="flex-column-item mat-select-margin" style="width:100% !important;" data-cy="ar-payment-type-field">
                <mat-label data-cy="ar-payment-type-label">Payment Type</mat-label>
                <mat-select data-cy="pay-type-list" [(ngModel)]="selectedPaymentMethod"
                  [disabled]="this.applyPayment || this.selectedLedgerItem" (selectionChange)="setPaymentMethod(); ">
                  <mat-option data-cy="pay-type-list-option" *ngFor="let method of paymentMethods" [value]="method">
                    {{ method.Name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="flexbox-item top-center-column input-container-height" *ngIf="this.DocPaymentProcessors.length>0 && selectedPaymentMethod?.enumARPayementTypeID === EnumARPaymentType.CreditCard" data-cy="ar-payment-processor-container">  
              <div *ngIf="this.DocPaymentProcessors.length>0" data-cy="ar-payment-processor-field-container">
                <mat-form-field style="width:100% !important;" data-cy="ar-payment-processor-field">
                  <mat-label data-cy="ar-payment-processor-label">Payment Processor</mat-label>
                  <mat-select data-cy="pay-account-list" [(ngModel)]="currentPaymentProcessorId"
                    (selectionChange)="setDocPaymentProcessor($event.value)">
                    <mat-option data-cy="pay-account-list-option" *ngFor="let pp of DocPaymentProcessors"
                      [value]="pp.PaymentProcessorId">
                      {{ pp.Name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="flexbox-item top-center-column input-container-height" data-cy="ar-payment-account-container">
              <mat-form-field class="flex-column-item mat-select-margin" style="width:100% !important;" data-cy="ar-payment-account-field">
                <mat-label data-cy="ar-payment-account-label">Payment Account</mat-label>
                <mat-select data-cy="pay-account-list" [(ngModel)]="depositARAccountID"
                  [disabled]="this.applyPayment || this.selectedLedgerItem">
                  <mat-option data-cy="pay-account-list-option" *ngFor="let arAccount of arAccountsAll"
                    [value]="arAccount.ARAccountID">
                    {{ arAccount.AccountName}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>



            <div class="flexbox-item top-center-column input-container-height" data-cy="ar-payment-description-container">
              <mat-form-field class="flex-column-item mat-select-margin" style="width:100%" data-cy="ar-payment-description-field">
                <mat-label data-cy="ar-payment-description-label">Description</mat-label>
                <input data-cy="pay-description" matInput value="" [disabled]="this.applyPayment"
                  [(ngModel)]="paymentDescription">
              </mat-form-field>
            </div>

            <div class="flexbox-item top-center-column input-container-height" style="text-align: left" data-cy="ar-payment-token-container">

              <div class="flex-row" style="flex: 1; margin-right: 10px;" data-cy="ar-payment-token-row">

                <mat-checkbox [(ngModel)]="this.initializeToken"
                  *ngIf="paymentTokens.length <= 1 && selectedPaymentMethod && selectedPaymentMethod.enumARPayementTypeID === EnumARPaymentType.CreditCard"
                  style="font-size: smaller;" data-cy="ar-payment-initialize-token">Initialize Reoccurring Payment</mat-checkbox>

                <mat-form-field class="flex-column-item mat-select-margin" style="width:100% !important;" *ngIf="checkValPayToken()" data-cy="ar-payment-token-field">
                  <mat-label data-cy="ar-payment-token-label">Valid Payment Tokens</mat-label>
                  <mat-select [(ngModel)]="selectedToken" data-cy="ar-payment-token-select">
                    <mat-option *ngFor="let tokens of paymentTokens" [value]="tokens" data-cy="ar-payment-token-option">
                      {{tokens.Description}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <!--make button for charge thing. whenever the selected value is add new or this is checked do pop-up for patient consent-->
              </div>
            </div>
            <div class="flexbox-item top-center-column" style="text-align: left" data-cy="ar-payment-action-buttons">

              <div style="flex: 1; margin-right: auto;margin-left: auto;text-align: center;" data-cy="ar-payment-action-buttons-container">
                <button data-cy="pay-save-payment-btn" class="tdo-button tdo-save"
                  *ngIf="(checkValPayToken() && this.selectedToken?.Description === 'Add New Token') || this.initializeToken "
                  (click)="OpenCardPaymentConsent()"
                  [disabled]="!checkIfPaymentAccountSelected() || !this.selectedPaymentMethod">
                  <span *ngIf="!ispaymentLoading">Start</span>
                  <mat-spinner class="payment-spinner" *ngIf="ispaymentLoading" [diameter]="20" data-cy="ar-payment-spinner-small"></mat-spinner>
                </button>

                <button data-cy="pay-save-payment-btn" class="tdo-button tdo-save"
                  *ngIf="checkValPayToken() && this.selectedToken?.Description !== 'Add New Token' && this.selectedToken"
                  (click)="chargeValPayToken(this.selectedToken)"
                  [disabled]="!checkIfTotalIsValid() || !checkIfPaymentAccountSelected() || !this.selectedPaymentMethod || this.applyPayment || !this.selectedToken ">
                  <span *ngIf="!ispaymentLoading">Charge</span>
                  <mat-spinner class="payment-spinner" *ngIf="ispaymentLoading" [diameter]="20" data-cy="ar-payment-charge-spinner"></mat-spinner>
                </button>

                <button data-cy="pay-save-payment-btn2" class="tdo-button tdo-save"
                        [disabled]="creditPaymentClicked || !checkIfPaymentAccountSelected()"
                  *ngIf="(!this.selectedToken && !this.initializeToken) && !this.applyPayment" (click)="submitPayment($event)">{{
                  saveButtonCaption }}</button>
              </div>
            </div>

          </div>

          <div class="flexbox-container-column" style="flex: 2; padding-left: 10px" data-cy="ar-payment-right-column">

            <div class="top-left-column"
              style="background: var(--tdo-purple-light); padding-top: 10px; padding-bottom: 10px; font-weight: bold"
              [ngClass]="!this.applyPayment ? 'hide-element' : ''" data-cy="ar-payment-approved-header">
              {{ (this.selectedPaymentMethod ? this.selectedPaymentMethod.enumARPayementTypeID : '') ===
              EnumARPaymentType.CreditCard ? 'Payment Approved' : 'Payment Recorded' }}
              <button
                *ngIf="selectedPaymentMethod?.enumARPayementTypeID === EnumARPaymentType.CreditCard && selectedPaymentMethod?.enumARPayementETypeID === enumEPayTypeCredit "
                data-cy="payment-details-print-receipt-btn" (click)="openPaymentReceipt()" class="tdo-button tdo-close"
                style="margin-right: 10px; float:right;margin-top: -6px;margin-bottom: -9px;" [disbled]="isPrintingReceipt" >Print Receipt</button>
            </div>

            <div class="flexbox-item top-right-column" style="width:100%;"
              [ngClass]="!this.applyPayment ? 'hide-element' : ''" data-cy="ar-payment-approved-content">
              Payment Amount: <span class="applyPayment-amount" data-cy="ar-payment-approved-amount">{{ this.approvedPaymentAmount | currency
                }}</span>&nbsp;<span class="applyPayment-orginalAmount"
                [ngClass]="!(this.approvedPaymentAmount < this.paymentAmount) ? 'hide-element' : ''" data-cy="ar-payment-approved-amount-note">(Full payment
                amount not approved)</span>
              <div style="padding-top:10px" data-cy="ar-payment-distribution-info">
                The payment was automatically distributed to the existing ledger items below starting with the oldest.
                If manual distribution is needed, please click the Clear Distributions button below and then manually
                enter the distributions.
              </div>
              <div style="padding-top: 10px; margin-top:10px; border-top: solid 1px #cccccc;" data-cy="ar-payment-remaining-section">

                <div style="display: flex;" data-cy="ar-payment-remaining-row">
                  <div style="flex: 1" data-cy="ar-payment-remaining-info">
                    Remaining Amount:
                    <span style="font-weight: bold" data-cy="ar-payment-remaining-amount">{{ this.paymentAmountNotDistributed | currency }}</span>

                    <div style="padding-top:10px" *ngIf="paymentAmountNotDistributed > 0" data-cy="ar-payment-remaining-message">
                      This remaining amount will be recorded as a credit for the patient.
                    </div>
                  </div>
                  <div style="flex: 1; text-align: right" data-cy="ar-payment-clear-button-container">
                    <button data-cy="pay-clear-distributions-btn" class="tdo-button tdo-save"
                      (click)="clearDistributions()">
                      Clear Distributions
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!--  ledger table-->
        <div style="flex: 1; overflow-y: auto; height: 405px; margin-top: -10px;" data-cy="ar-payment-ledger-table-container">
          <tdo-table [dataSource]="this.dataLedgerItems" [isMultiSelection]="true" [isSearchable]="true"
            [isUsePaginator]="true" [footerData]="footerData" [searchPredicate]="searchPredicate"
            (rowSelected)="onRowSelected($event)" [cypressControlIdentifier]="'pay-fee-row'" data-cy="ar-payment-ledger-table">
            <tdo-table-column displayName="Post Date" propertyName="PostDate" isSortable="true"
              [rowTemplate]="postDate" data-cy="ar-payment-ledger-col-date">
              <ng-template #postDate let-row>
                <div *ngIf="row.PostDate" data-cy="ar-payment-ledger-date">{{ convertUTCDateToLocalDateFromString(row.PostDate) | date }}</div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Reference" propertyName="Reference" isSortable="true"
              [rowTemplate]="reference" data-cy="ar-payment-ledger-col-reference">
              <ng-template #reference let-row>
                <div *ngIf="row.Reference" data-cy="ar-payment-ledger-reference">{{ row.Reference }}</div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Code" targetObjectName="dataARTransactionItem" propertyName="Code"
              isSortable="true" [rowTemplate]="code" data-cy="ar-payment-ledger-col-code">
              <ng-template #code let-row>
                <div *ngIf="row.model.dataARTransactionItemList && row.model.dataARTransactionItemList.Code" data-cy="ar-payment-ledger-code">
                  {{ row.model.dataARTransactionItemList.Code }}
                </div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Description" propertyName="Description" isSortable="true"
              [rowTemplate]="description" data-cy="ar-payment-ledger-col-description">
              <ng-template #description let-row>
                <div *ngIf="row.model.Description" style="max-width: 500px; padding-top: 4px; padding-bottom: 4px;" data-cy="ar-payment-ledger-description">
                  {{ row.model.Description }}
                </div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="AR Account" propertyName="ARAccountID" isSortable="true"
              [rowTemplate]="araccount" data-cy="ar-payment-ledger-col-account">
              <ng-template #araccount let-row>
                <div *ngIf="row.model.DoctorARLocId" data-cy="ar-payment-ledger-account">
                  {{ this.returnARAccountName(row.model.DoctorARLocId) }}
                </div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Billed" propertyName="Amount1" isSortable="true" [rowTemplate]="debit" data-cy="ar-payment-ledger-col-billed">
              <ng-template #debit let-row>
                <div *ngIf="row.model.enumARLedgerItemTypeID == LEDGER_ITEM_TYPE.Debit" data-cy="ar-payment-ledger-billed">
                  {{ row.model.Amount | currency }}
                </div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Payments" propertyName="PaymentsTotal" isSortable="true"
              [rowTemplate]="payments" data-cy="ar-payment-ledger-col-payments">
              <ng-template #payments let-row>
                <div *ngIf="row.model.PaymentsTotal" data-cy="ar-payment-ledger-payments">
                  {{ row.model.PaymentsTotal | currency }}
                </div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Amount Due" propertyName="RunningBalance" isSortable="true"
              [rowTemplate]="due" data-cy="ar-payment-ledger-col-due">
              <ng-template #due let-row>
                <div data-cy="ar-payment-ledger-due">{{ row.model.AmountDuePatient | currency }}</div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Apply" propertyName="ApplyPayment" isSortable="true" [rowTemplate]="apply" data-cy="ar-payment-ledger-col-apply">
              <ng-template #apply let-row>
                <div class="input-container-height" data-cy="ar-payment-ledger-apply-container">
                  <mat-form-field floatLabel='never' [style.width.px]=80 data-cy="ar-payment-ledger-apply-field">
                    <input data-cy="pay-distribution-amount-btn" matInput placeholder="" width="80px"
                      style="font-weight: bold"
                      [ngClass]="!(this.applyPayment && row.model.AmountDuePatient > 0) ? 'hide-element' : ''"
                      (change)="saveCurrencyField($event, 'ApplyPayment', row.model.LedgerID); this.setPaymentAmountDistributionRemaining();"
                      [ngModel]="row.model.ApplyPayment | currency">
                  </mat-form-field>
                </div>

              </ng-template>
            </tdo-table-column>
          </tdo-table>
        </div>

      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 10px;" data-cy="ar-payment-footer">
      <div style="flex: 1; margin-right: 6px;" data-cy="ar-payment-footer-spacer"></div>
      <button data-cy="pay-cancel-bottom-btn" *ngIf="!this.applyPayment" (click)="close(false); cancelClicked();"
        class="tdo-button tdo-close" style="margin-right: 10px;">Cancel</button>
      <button data-cy="pay-save-bottom-btn" class="tdo-button tdo-save" style="margin-right: 6px;"
        (click)="savePaymentDistributionClicked()"
        *ngIf="this.applyPayment">Save Distribution</button>
    </div>
  </div>
</div>
